







































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import ArticleApi from '@/api/article/index'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
@Component({
  components: {
    CustomForm
  }
})
export default class ArticleSelect extends AbpBase {
  // 是否显示按钮
  @Prop({
    type: Boolean,
    default: true
  })
  showBtn!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  show!: boolean

  @Watch('show')
  showChange(show) {
    this.modal1 = !this.modal1
  }

  modal1: boolean = false
  total: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  data = []
  filters = [
    {
      label: '关键字搜索：',
      type: 'input',
      props: {
        placeholder: ''
      },
      key: 'Filter'
    },
    {
      label: '文章分类',
      type: 'select',
      key: 'Categories',
      defaultValue: [],
      props: {
        'max-tag-count': 2,
        multiple: true,
        placeholder: '请选择'
      },
      options: []
    }
  ]
  columns: any[] = [
    {
      title: '头图',
      slot: 'picture',
      align: 'center',
      width: 80
    },
    {
      title: '文章标题',
      key: 'title',
      align: 'center'
    },
    {
      title: '所属分类',
      key: 'category',
      align: 'center'
    },
    {
      title: '相关商品数',
      key: 'productCount',
      align: 'center'
    },
    {
      title: '转发',
      key: 'forward',
      align: 'center'
    },
    {
      title: '收藏数',
      key: 'collection',
      align: 'center'
    },
    {
      title: '阅读数',
      key: 'readCount',
      align: 'center'
    },
    {
      title: '点赞数',
      key: 'thumbsUps',
      align: 'center'
    },
    {
      title: '创建时间',
      slot: 'creationTime',
      align: 'center'
    }
  ]

  async mounted() {
    this.getCategoryList()
  }
  @Watch('modal1')
  async modalShowChange(show) {
    if (show) await this.submitFn()
  }

  /**
   * 获取所有文章分类
   */
  getCategoryList() {
    ArticleApi.getCategoryList().then(res => {
      this.filters.forEach(item => {
        if (item.key == 'Categories') {
          switch (item.type) {
            case 'select':
              res.data.items = res.data.items.map(child => {
                return {
                  value: child.id,
                  text: child.name
                }
              })
              item.options = res.data.items
              break
          }
        }
      })
    })
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  submitChange(form, valid) {
    if (valid) {
      this.getArticleList(form)
    }
  }

  /**
   * 获取文章列表
   */
  getArticleList(form = {}) {
    let Filter = form['Filter']
    let Categories = form['Categories']
    let { pageSize, pageIndex } = this
    ArticleApi.getArticleList(
      pageSize,
      pageIndex,
      Categories,
      Filter,
      null,
      true
    )
      .then(res => {
        let { totalCount, items } = res.data
        this.total = totalCount
        this.data = items
      })
      .catch(() => {
        this.total = 0
        this.data = []
      })
  }

  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
    await this.submitFn()
  }
  currentChange(currentRow, oldCurrentRow) {
    this.$emit('on-row-selected', currentRow)
    this.modal1 = false
  }

  cancel() {
    this.$emit('on-row-selected', null)
    this.modal1 = false
  }
}
